<app-title title="Organization Details"></app-title>
<div class="container">
  <div class="bg-white p-3 shadow-md rounded-md" *ngIf="orgData">
    <h3 class="poppins-semibold">Organization Details</h3>
    <div class="text-gray-700">
      <div class="grid md:grid-cols-2 sm:grid-cols-1 text-sm">
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold">Name:</div>
          <div class="px-4 py-2">{{orgData.name}}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold">Code:</div>
          <div class="px-4 py-2">{{orgData.code}}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2"><i class="pi pi-at"></i> Admin Email:
          </div>
          <div class="px-4 py-2"><a class="text-blue-800 no-underline" href="mailto:{{orgData.adminEmail}}" target="_blank">{{orgData.adminEmail}}</a></div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2"><i class="pi pi-phone"></i>Admin Phone:</div>
          <div class="px-4 py-2">{{orgData.adminPhone || 'NA'}}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2"><i class="pi pi-hourglass"></i>Time Zone:</div>
          <div class="px-4 py-2">{{orgData.timeZone || 'NA'}}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2"><i class="pi pi-language"></i>Language:</div>
          <div class="px-4 py-2">
            {{orgData.language || 'NA'}}
          </div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold">Status:</div>
          <div class="px-4 py-2">
            <a *ngIf="orgData.orgStatus == 'REJECTED'" class="text-red-600 flex items-center gap-2"><i class="pi pi-times-circle" ></i>Rejected</a>
            <a *ngIf="orgData.orgStatus == 'VERIFIED'" class="text-secondary flex items-center gap-2"><i class="pi pi-check-circle" ></i>Verified</a>
            <p *ngIf="orgData.orgStatus !== 'VERIFIED' && orgData.orgStatus !== 'REJECTED'">{{orgData.orgStatus.replaceAll('_', ' ') | titlecase}}</p>
          </div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2">GSTIN Number:</div>
          <div class="px-4 py-2">
            {{orgData.gstInNumber || 'NA'}}
          </div>
        </div>
      </div>
      
        <!-- Subscription Section -->
        <div *ngIf="orgData.subscriptions">
          <h3 class="poppins-semibold">Subscription Details</h3>
          <div class="grid md:grid-cols-2 sm:grid-cols-1 text-sm" >
           <div class="grid grid-cols-2">
             <div class="px-4 py-2 font-semibold">Tier:</div>
             <div class="px-4 py-2">{{orgData.subscriptions[0].tier}}</div>
           </div>
           <div class="grid grid-cols-2">
             <div class="px-4 py-2 font-semibold">Total Credits:</div>
             <div class="px-4 py-2">{{orgData.subscriptions[0].totalCredits  | indianNumber}}</div>
           </div>
           <div class="grid grid-cols-2">
             <div class="px-4 py-2 font-semibold">Credits Left:</div>
             <div class="px-4 py-2">{{orgData.subscriptions[0].creditsLeft | indianNumber}}</div>
           </div>
           <div class="grid grid-cols-2">
             <div class="px-4 py-2 font-semibold">Expire At:</div>
             <div class="px-4 py-2">{{orgData.subscriptions[0].endDate | date:'mediumDate' }}</div>
           </div>
           <div class="grid grid-cols-2">
             <div class="px-4 py-2 font-semibold">Subscription Status:</div>
             <div class="px-4 py-2">{{orgData.subscriptions[0].subscriptionStatus}}</div>
           </div>
         </div>
        </div>
      <div class="flex justify-end mt-4 gap-6" >
        <p-button label="Add Subscription" icon="pi pi-plus-circle" size="small" [outlined]="true" (click)="addSubscriptionPopup()" />
        <p-button label="Edit" icon="pi pi-pen-to-square" size="small" [routerLink]="'/settings/org/update/'+ orgData.id" [outlined]="true" />
      </div>
    </div>

  </div>
</div>


<p-dialog [(visible)]="isAddSubscriptionPopupVisible" header="Add Subscription" [modal]="true" [closable]="true" styleClass="!h-auto">
  <form [formGroup]="addSubscriptionForm" (ngSubmit)="addSubscription()">
    <section class="grid grid-cols-2 gap-8 px-8 py-12">
      <section class="flex flex-col gap-2">
        <label for="tier">Tier</label>
        <p-autoComplete
          formControlName="tier"
          [suggestions]="filteredSubscriptions"
          (completeMethod)="filterSubscription($event)"
          [forceSelection]="true"
          [minLength]="1"
          [dropdown]="true"
          placeholder="Select Subscription"
        />
      </section>

      <section class="flex flex-col gap-2">
        <label for="duration">Duration</label>
        <p-autoComplete
          formControlName="duration"
          [suggestions]="filteredDurations"
          (completeMethod)="filterDuration($event)"
          [forceSelection]="true"
          [minLength]="1"
          [dropdown]="true"
          placeholder="Select Duration"
        />
      </section>
    </section>

    <section class="flex justify-end gap-2 mt-4">
      <p-button label="Cancel" (click)="isAddSubscriptionPopupVisible = false" [outlined]="true" />
      <p-button label="Submit" type="submit" />
    </section>
  </form>
</p-dialog>